import react, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./Login.scss";
import { Alert, useMediaQuery, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import lightlogo from "../../Img/light-mode-logo.png";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import lgleft from "../../Img/lgleft.png";
import AuthLeft from "./AuthLeft";
import AuthHeader from "./AuthHeader";
import Loader from "../Loader";
import usercalls from "../../Axios";
import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import { Email } from "@mui/icons-material";

export default function Reset() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  // console.log(lg, "show");

  const navigate = useNavigate();
  const path = usercalls();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showCnfPassword, setShowCnfPassword] = useState(false);
  const [otp, setOtp] = useState("");
  const [load, setLoad] = useState(false);

  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowCnfPassword = () => setShowCnfPassword(!showCnfPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!otp) {
      toast.error("OTP is required");
      return;
    }
    if (!password) {
      toast.error("New password is required");
      return;
    } else if (!passwordRegex.test(password)) {
      toast.error(
        "New password must contain at least 8 characters, one uppercase letter, one number, and one special character (e.g., Abc@1234)"
      );
      return;
    }

    if (!confirmPassword) {
      toast.error("Please confirm your new password");
      return;
    } else if (confirmPassword !== password) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/reset`;
      const payload = {
        email: localStorage.getItem("email"),
        otp: otp,
        password: password,
      };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result.success === true) {
        toast.success(result.message);
        setPassword("");
        setConfirmPassword("");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
        setLoad(false);
      } else {
        toast.error(result.message);
        setLoad(false);
      }
    } catch (error) {
      console.error("Error during reset password:", error);
      toast.error("Something went wrong. Please try again.");
      setLoad(false);
    }
  };

  return (
    <>
      {/* <AuthHeader/> */}
      <ToastContainer />
      <div className="register">
        {load && <Loader />}
        <Grid
          container
          component="main"
          sx={{ alignItems: "center", height: !lg && "100vh" }}
          className={!md ? "medium" : ""}
        >
          {lg && (
            <Grid item xs={12} sm={12} md={6} lg={5.5}>
              <AuthLeft />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={6.5}>
            <Grid
              container
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  sx={{
                    my: md && 3,
                    mx: md && 8,
                    display: "flex",
                    flexDirection: "column",
                    //  padding: '28px 25px',
                    alignItems: "center",
                    maxWidth: "700px",
                    margin: "0 auto",
                    padding: "10px",
                  }}
                >
                  {/* <Loginbtn/> */}
                  <Typography
                    component="h1"
                    variant="h5"
                    className="text-center c-accout"
                    sx={{ mt: 1, mb: 3, m: "auto" }}
                  >
                    Reset Password
                  </Typography>
                  <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 1, width: "100%" }}
                  >
                    <div className="email-fill" style={{ marginTop: "10px" }}>
                      <div className="email-name">
                        Enter OTP<span className="required"> * </span>
                      </div>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-number"
                          type={"number"}
                          onChange={(e) => {
                            setOtp(e.target.value);
                          }}
                        // endAdornment={
                        //   <InputAdornment position="end">
                        //     <IconButton
                        //       aria-label={
                        //         showPassword
                        //           ? "hide the otp"
                        //           : "display the otp"
                        //       }
                        //       onClick={handleClickShowPassword}
                        //       edge="end"
                        //     >
                        //       {showPassword ? (
                        //         <VisibilityOff />
                        //       ) : (
                        //         <Visibility />
                        //       )}
                        //     </IconButton>
                        //   </InputAdornment>
                        // }
                        // label="Password"
                        />
                      </FormControl>
                    </div>
                    <div className="email-fill" style={{ marginTop: "10px" }}>
                      <div className="email-name">
                        New Password<span className="required"> * </span>
                      </div>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showPassword ? "text" : "password"}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label={
                                  showPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {!showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        // label="Password"
                        />
                      </FormControl>
                    </div>

                    <div className="email-fill" style={{ marginTop: "10px" }}>
                      <div className="email-name">
                        Confirm Password<span className="required"> * </span>
                      </div>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showCnfPassword ? "text" : "password"}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label={
                                  showCnfPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowCnfPassword}
                                edge="end"
                              >
                                {!showCnfPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        // label="Password"
                        />
                      </FormControl>
                    </div>

                    <div className="common-btn">
                      <Button type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                        Reset
                      </Button>
                    </div>

                    <div className="text-center accnt-sign mt-10">
                      <Link to="/register" variant="body2">
                        Don't have an account? <span>Sign Up</span>
                      </Link>
                    </div>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
